import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Helmet } from 'react-helmet';
import SettingsPage, { SettingsTabs } from 'components/SettingsPage';
import BillingOverview from 'components/Billing/Overview';
import BillingHistory from 'components/Billing/History';
import BillingCreditCard from 'components/Billing/CreditCard';

const SECTIONS = [
  { id: 'overview', label: 'Overview' },
  { id: 'billing_history', label: 'Billing history' },
  { id: 'credit_card', label: 'Card' },
];

// Settings > Billing (/billing?section=…): your plan, past payments and the
// card you pay with. The section lives in the URL (viewStore.billingInfo).
@inject('viewStore') @observer
class BillingIndexPage extends Component {

  handleTabChange = (section) => {
    const { viewStore } = this.props;
    viewStore.billingInfo = { section };
    viewStore.loadBillingOverview();
  }

  render() {
    const { billingInfo } = this.props.viewStore;
    const section = SECTIONS.some((tab) => tab.id === (billingInfo && billingInfo.section))
      ? billingInfo.section
      : 'overview';
    return (
      <React.Fragment>
        <Helmet>
          <title>Billing | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Billing"
          description="Your Field Nexus plan, past payments and the card you pay with."
          tabs={<SettingsTabs tabs={SECTIONS} selected={section} onChange={this.handleTabChange} label="Billing" />}
        >
          {section === 'overview' && <BillingOverview />}
          {section === 'billing_history' && <BillingHistory />}
          {section === 'credit_card' && <BillingCreditCard />}
        </SettingsPage>
      </React.Fragment>
    );
  }
}

export default BillingIndexPage;
